<% if ('width' in field) { %>
	<% if (field.width <= 12) { %>
<div class="<% if (field.responsive) { %>col-12 col-xl-<%= field.width %><% } else { %>col-<%= field.width %><% } %>">
	<% } else { %>
<div class="col-auto" style="width:<%= field.width %>px">
	<% } %>
<% } else { %>
<div class="col" style="min-width:<%= 'width' in form.params ? form.params.width : '400' %>px;">
<% } %>

	<% field.fields.forEach((field) => { %>
		<%- include(field.type, { form, field }) %>
	<% }); %>

</div>
